import { render, staticRenderFns } from "./ElementTeamMember.vue?vue&type=template&id=6631d6a0&"
import script from "./ElementTeamMember.vue?vue&type=script&lang=js&"
export * from "./ElementTeamMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports